// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-437107dd81b0c4c91127.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-8804a6a0a7c0f0ff0949.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-eb7fed960e8bc27866a8.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-e48247d6584fa5327626.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-4b68c5c972f2bd63a9b9.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-07f96bac95f43cd92d4e.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-830c50ef616e1768f87f.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-6ebf6863c00ef5ebe432.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-d19497eca3c2f1c76475.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-245748d92a276cee3d37.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-b9dd56f18f00f185c781.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-0ec343cf8347583cb357.js";
	if (chunkId === 863) return "subsite-china/072d4843-b618a36bcb4cf63debb1.js";
	if (chunkId === 208) return "subsite-china/2aacc723-aaa2e19d46138ceba232.js";
	if (chunkId === 344) return "subsite-china/bf322c48-a36857115dfeb95eac09.js";
	if (chunkId === 811) return "subsite-china/22e32791-447426b6b15bf468df90.js";
	if (chunkId === 312) return "subsite-china/409a021e-cc0a5303ea856c8b17f0.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-3c6640f675c36c6aeb8a.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-c32b05873995f9d747a9.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-443ed77bc2bf4a1ede4b.js";
	if (chunkId === 731) return "subsite-china/731-9851442bf0e7d25986f4.js";
	if (chunkId === 843) return "subsite-china/843-e0c23d9ef9cc52ce2684.js";
	// return url for filenames based on template
	return undefined;
};